import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import SideBar from "../components/SideBar";
import { Typography, CircularProgress, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import LockResetIcon from "@mui/icons-material/LockReset";
import axios from "axios";
import EditUserModal from "../pages/EditUserModal";
import ResetPassword from "../pages/ResetPassword";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function CallEvolution() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isSideBarOpen, setIsSideBarOpen] = useState(true);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openResetModal, setOpenResetModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const userData = JSON.parse(localStorage.getItem("userData"));
        const response = await axios.get(
          "https://tarabot.com-eg.net/api/Users/V1/GetUsers",
          {
            headers: {
              CompanyID: "221005",
              AccessToken: userData.Data.AccessToken,
            },
          }
        );

        if (response.data.Success) {
          const formattedUsers = response.data.Data.map((user, index) => ({
            ...user,
            id: user.UserID || index,
          }));
          setUsers(formattedUsers);
        } else {
          console.error("Error fetching users:", response.data.Message);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        if (error.response && error.response.status === 401) {
          console.log("Session expired, logging out...");
          localStorage.removeItem("userData"); // مسح بيانات المستخدم
          navigate("/"); // إعادة التوجيه إلى الصفحة الرئيسية
        }
      } finally {
        setLoading(false); // إخفاء حالة التحميل
      }
    };

    fetchUsers();
  }, []);

  const handleEdit = (user) => {
    setSelectedUser(user);
    setOpenEditModal(true);
  };
  const handleReset = (user) => {
    setSelectedUser(user);
    setOpenResetModal(true);
  };

  const handleCloseModal = () => {
    setOpenEditModal(false);
    setOpenResetModal(false);
    setSelectedUser(null);
  };

  const columns = [
    { field: "UserID", headerName: t("id"), width: 90 },
    { field: "Username", headerName: t("userName"), width: 150 },
    { field: "DispalyName", headerName: t("name"), width: 150 },
    { field: "RoleEnglishName", headerName: t("role"), width: 150 },
    {
      field: "IsLocked",
      headerName: t("isLocked"),
      width: 150,
      type: "boolean",
    },
    { field: "BranchEnglishName", headerName: t("branch"), width: 150 },
    {
      field: "actions",
      headerName: t("actions"),
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Box>
          <IconButton color="primary" onClick={() => handleEdit(params.row)}>
            <EditIcon sx={{ color: "orange" }} />
          </IconButton>
          <IconButton color="secondary" onClick={() => handleReset(params.row)}>
            <LockResetIcon sx={{ color: "#87182b" }} />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Box sx={{ display: "flex" }}>
      <SideBar
        open={isSideBarOpen}
        toggleOpen={() => setIsSideBarOpen(!isSideBarOpen)}
      />
      <Box
        sx={{
          height: "calc(100vh - 130px)",
          width: "95%",
          marginTop: "70px",
          marginLeft: isSideBarOpen ? "5px" : "250px",
          transition: "margin-left 0.3s",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            marginBottom: "20px",
            fontWeight: "bold",
            color: "#263150",
            marginRight: "10px",
          }}
        >
          {t("callEvolution")}
        </Typography>

        {loading ? (
          <CircularProgress />
        ) : (
          <DataGrid
            rows={users}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection
            disableRowSelectionOnClick
            sx={{
              marginRight: "10px",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "red",
                color: "#63729A",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold",
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                backgroundColor: "#324c95",
                color: "white",
              },
              "& .MuiDataGrid-row:nth-of-type(even)": {
                backgroundColor: "#e0e0e0",
              },
            }}
          />
        )}
      </Box>

      {/* استدعاء المودال */}
      <EditUserModal
        open={openEditModal}
        handleClose={handleCloseModal}
        user={selectedUser}
      />
      <ResetPassword
        open={openResetModal}
        handleClose={handleCloseModal}
        user={selectedUser}
      />
    </Box>
  );
}
